












































































import { AxiosError } from 'axios';
import { PropType, defineComponent, ref } from '@vue/composition-api';

import { IWorkflow } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';

import { createNamespacedHelpers, useStore } from 'vuex-composition-helpers';
import { IRootState } from '@/store';
import {
  IWorkflowStoreState,
  IWorkflowGetters,
  IWorkflowActions,
  IWorkflowMutations
} from '@/store/workflow';

import DetailOptionsButton from '@/components/common/DetailOptionsButton.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default defineComponent({
  name: 'WorkflowDetailOptionsButton',

  components: {
    ConfirmationDialog,
    DetailOptionsButton
  },

  mixins: [auth],

  props: {
    workflow: {
      type: Object as PropType<IWorkflow>,
      required: true
    }
  },

  setup(props, { emit }) {
    const store = useStore<IRootState>();

    const { useActions } = createNamespacedHelpers<
      IWorkflowStoreState,
      IWorkflowGetters,
      IWorkflowActions,
      IWorkflowMutations
    >(store, 'workflow');

    const { deleteWorkflow } = useActions(['deleteWorkflow']);

    const error = ref<ISystemError | null>(null);

    function clearErrors() {
      error.value = null;
    }

    const isDeleteInProgress = ref(false);

    const deleteStateDialog = ref(false);

    function cancelDeleteDialog() {
      deleteStateDialog.value = false;
    }

    async function removeWorkflow() {
      try {
        isDeleteInProgress.value = true;
        await deleteWorkflow(props.workflow.id!);

        deleteStateDialog.value = false;
      } catch (err) {
        error.value = setErrorFromAxiosError(err as AxiosError);
      } finally {
        isDeleteInProgress.value = false;
      }
    }

    return {
      error,
      deleteStateDialog,
      isDeleteInProgress,

      cancelDeleteDialog,
      removeWorkflow,
      clearErrors
    };
  }
});
